var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6595_25534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72797 2.22732C9.47464 1.97398 9.13463 1.83398 8.7813 1.83398H4.0013C3.26797 1.83398 2.66797 2.43398 2.66797 3.16732V13.834C2.66797 14.5673 3.2613 15.1673 3.99464 15.1673H12.0013C12.7346 15.1673 13.3346 14.5673 13.3346 13.834V6.38732C13.3346 6.03398 13.1946 5.69398 12.9413 5.44732L9.72797 2.22732ZM10.0013 12.5007H6.0013C5.63464 12.5007 5.33464 12.2007 5.33464 11.834C5.33464 11.4673 5.63464 11.1673 6.0013 11.1673H10.0013C10.368 11.1673 10.668 11.4673 10.668 11.834C10.668 12.2007 10.368 12.5007 10.0013 12.5007ZM10.0013 9.83398H6.0013C5.63464 9.83398 5.33464 9.53398 5.33464 9.16732C5.33464 8.80065 5.63464 8.50065 6.0013 8.50065H10.0013C10.368 8.50065 10.668 8.80065 10.668 9.16732C10.668 9.53398 10.368 9.83398 10.0013 9.83398ZM8.66797 5.83398V2.83398L12.3346 6.50065H9.33463C8.96797 6.50065 8.66797 6.20065 8.66797 5.83398Z",
    fill: "#A7A5A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6595_25534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.93fdd78aa39494a623dbbf3f202eb468.svg";
export { ForwardRef as ReactComponent };